const arrToObjIdAsKey = (arr, key = 'id') => {
	const obj = {};
	for (const item of arr) {
		obj[item[key]] = item;
	}
	return obj;
};

export default arrToObjIdAsKey;
